/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICittaNavigationMenu contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum navigationMenuSource {
    retailServerOnly = 'retailServerOnly',
    cmsOnly = 'cmsOnly',
    all = 'all'
}

export interface ICittaNavigationMenuConfig extends Msdyn365.IModuleConfig {
    categoryImageSettings?: Msdyn365.IImageSettings;
    displayCategoryImage?: boolean;
    navigationMenuSource?: navigationMenuSource;
    enableMultilevelMenu?: boolean;
    menuLevelSupport?: number;
    enabletopMenu?: boolean;
    rootMenuNavigation?: string;
    cmsNavItems?: ICmsNavItemsData[];
    className?: string;
}

export interface ICittaNavigationMenuResources {
    menuAriaLabel: string;
    backButtonAriaLabel: string;
    allCategoryMenuText: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
}

export interface ICittaNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: ICittaNavigationMenuResources;
    config: ICittaNavigationMenuConfig;
}
